import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-patientcases-main",
    templateUrl: "./patientcases.main.component.html"
})
export class PatientCasesMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
